import { render, staticRenderFns } from "./add-product-component.vue?vue&type=template&id=5f6291f6&scoped=true"
import script from "./add-product-component.vue?vue&type=script&lang=js"
export * from "./add-product-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6291f6",
  null
  
)

export default component.exports